define.alias("shared/components/shared/addon-details-card", "preview-grid/components/shared/addon-details-card");